import script from "./generic-select.vue?vue&type=script&setup=true&lang=js"
export * from "./generic-select.vue?vue&type=script&setup=true&lang=js"

import "./generic-select.vue?vue&type=style&index=0&id=1f11cf09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f11cf09"]])

export default __exports__